import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbInternalConfigurationFactory;
/* eslint-disable */
/**
 * Misc
 * Miscellaneous utilities and test-only endpoints
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/misc.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface AbInternalConfiguration
 */

export class AbInternalConfigurationFactory {}
_AbInternalConfigurationFactory = AbInternalConfigurationFactory;
_defineProperty(AbInternalConfigurationFactory, "FromJSON", function (json) {
  return _AbInternalConfigurationFactory.FromJSONTyped(json, false);
});
_defineProperty(AbInternalConfigurationFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'runtimeConfig': json['runtimeConfig'] === null || json['runtimeConfig'] === undefined ? json['runtimeConfig'] : json['runtimeConfig']
  };
});
_defineProperty(AbInternalConfigurationFactory, "ToJSON", function (value) {
  return _AbInternalConfigurationFactory.ToJSONTyped(false, value);
});
_defineProperty(AbInternalConfigurationFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'runtimeConfig': value.runtimeConfig
  };
});
//# sourceMappingURL=AbInternalConfiguration.js.map
